<div class="container" dir="rtl">
  <div *ngIf="report?.EmissionScore" class="container">
    <ng-container *ngIf="report?.EmissionScore !== -1">
      <div class="report-card">
        <div class="score-section py-4">
          <div class="score-number">
            <small>100 /</small>
            {{ report?.EmissionScore }}
          </div>

          <div class="progress-track">
            <div
              class="progress-fill"
              [style.width.%]="report?.EmissionScore"
            ></div>
          </div>

          <div class="text-center pt-4">
            <span
              class="status-badge"
              [ngClass]="{
                'good': report?.EmissionScore >= 70,
                'medium': report?.EmissionScore >= 40 && report?.EmissionScore < 70,
                'bad': report?.EmissionScore < 40
                }">
              {{ report?.EmissionLevel }}
            </span>
          </div>
        </div>

        <div class="report-section">
          <h3>گزارش تحلیل</h3>
          <div class="report-text">
            {{ report?.DiagnosticReport }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
